import Cookies from 'universal-cookie';
const cookie = new Cookies();

export const customHeaderTemplate = (data) => {
  return (
    <div>
      <div className="d-flex">
        <div>
          <i className="icon-window-filled modal-close-icon pointer F-size14" onClick={data?.onHide}></i>
          {/* <i className="icon-window-filled pointer F-size14 icon-minimize"></i> */}
        </div>
      </div>
    </div>
  );
};

export const customFooter = () => {
  return <div></div>;
};

export const tenantId = cookie.get('tenantId') || null;
export const tenant_sk = cookie.get('tenantSk') || null;
export let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

export const colorsArray = [
  '#6EDCFF',
  '#FD9090',
  '#6DD507',
  '#EFC804',
  '#CEAFF2',
  '#FF8C01',
  '#C2C2C2',
  '#FFE3C2',
  '#159DFF',
  '#35B16F',
  '#FF372D',
  '#BFB668',
];
